.list-item-y-padding {
  padding: 8px 0;
}

.inner-link {
  cursor: pointer;
}
